import { HTMLAttributes } from "react"
import { callCSSFn, CSSFn, styled, StyleProps } from "../../styles"
import { boxCss } from "../../Box"
import { makeInputStyle } from "../../Input/InputStyles"

export const Container = styled.div({
  ...boxCss,
  width: `100%`,
  position: `relative`,
})

export const StyledInput = styled.input<HTMLAttributes<HTMLInputElement>>((props: StyleProps & { css?: CSSFn }) => ({
  width: `100%`,
  outline: `none`,
  ...makeInputStyle(props),
  // position: `relative`,
  // alignItems: `center`,
  ...callCSSFn(props),
}))
